import type { TOC } from '@ember/component/template-only';
import type Model from '@ember-data/model';
import { eq } from 'ember-truth-helpers';
import RecordSelectSelectAll from 'garaje/components/record-select/select-all';
import SortableHeaderColumn from 'garaje/components/sortable-header-column';
import type { SortDirection } from 'garaje/components/sortable-header-column';

interface RecordSelectHeadSignature<T = Model> {
  Args: {
    fields: { displayName: string; name: string }[];
    models: T[];
    onDeselectAll: () => void;
    onSelectAll: () => void;
    selectedModels: T[];
    sortDirection: SortDirection;
    sortField: string;
    sortRows: (field: string, direction: SortDirection) => void;
  };
  Element: HTMLTableSectionElement;
}

const RecordSelectHead: TOC<RecordSelectHeadSignature> = <template>
  <thead ...attributes>
    <tr>
      <th class="align-middle border-b p-2 w-4">
        <RecordSelectSelectAll
          data-test-select-all-checkbox
          @onSelectAll={{@onSelectAll}}
          @onDeselectAll={{@onDeselectAll}}
          @models={{@models}}
          @selectedModels={{@selectedModels}}
        />
      </th>
      {{#each @fields as |field|}}
        <th class="align-middle border-b p-2">
          <SortableHeaderColumn
            @name={{field.displayName}}
            @isActive={{eq @sortField field.name}}
            @sortDirection={{@sortDirection}}
            @sortField={{field.name}}
            @sortAction={{@sortRows}}
          />
        </th>
      {{/each}}
    </tr>
  </thead>
</template>;

export default RecordSelectHead;
